import DialogBase, { DialogBaseProps } from "./DialogBase";

export type MessageDialogBaseProps = DialogBaseProps & {};

const MessageDialogBase = ({ ...props }: MessageDialogBaseProps) => {
  return (
    <DialogBase
      {...props}
      onDialogResult={(e) => {
        // 注意! 要放在 ...props 後面覆寫事件
        props.onDialogResult?.(e);
      }}
    />
  );
};

export default MessageDialogBase;
